import ReviewsList from './ReviewsList'

export default ReviewsList
